<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container.px-6
    div.heading-5.basic700--text {{ $t('send_message_to_customer') }}
    div.text-md.font-normal.basic700--text {{ $t('send_message_to_customer_desc') }}
    v-divider.my-6

    credit-alert(:credit="creditBalance" :title="$t('start_sending_message')" :showTitle="true" titleFont="heading-6" descFont="text-xs" buttonSize="button-sm")

    v-row(no-gutters)
      v-col(cols="12" sm="6")
        div.heading-6.basic700--text.mt-3 SMS Header
        v-text-field.text-sm.mt-1.round-xl(v-model="smsHeader" prefix="RM0" placeholder="Enter header here" outlined dense height="48" :disabled="!editingHeader" :loading="isSavingHeader" :rules="smsHeaderRules" :error="!hasSmsHeader" hide-details="auto")
          template(v-slot:append)
            v-btn.button-sm(v-if="!editingHeader" outlined style="margin-top: -2px" @click.stop="editingHeader = true") Edit
            v-btn.button-sm(v-else outlined :loading="isSavingHeader" style="margin-top: -2px" @click.stop="saveSmsHeader") Save
        yc-text-field.mt-3(:label="$t('event_name')" v-model="eventName" hide-details="auto")
        yc-text-area.mt-3(:label="$t('message_template')" :placeholder="$t('send_message_placeholder')" v-model="message")
        div.text-xs.font-normal.basic600--text.mt-2 Character Count {{messageLength.length}} | SMS Count {{messageLength.numSMS}} | Cost RM {{messageLength.cost.toFixed(2)}}
        div.heading-6.basic700--text.mt-4 {{ $t('message_preview') }}
        v-card.message-preview-border.pa-4.mt-4.round-xl(outlined)
          div.text-md.font-normal(:class="message ? 'basic700--text' : 'basic500--text'") {{ senderIDPrefix }}{{ message || $t('send_message_placeholder') }}

        v-btn.button-md.mt-8.mb-10(color="info500" :dark="!disabledSend" depressed :disabled="disabledSend" @click="openSendMessageDialog = true") {{ $t('send') }}

  .modals
    send-message-dialog(v-if="openSendMessageDialog" :open.sync="openSendMessageDialog" :eventName="eventName" :message="message" :group="id" :donors="selectedDonors" @redirect="closeRedirect")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SendMessageDialog from '@/components/donation/dialogs/SendMessageDialog.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'

export default {
  name: 'SegmentSendMessage',
  components: { SendMessageDialog, CreditAlert },
  props: ['id'],
  data () {
    return {
      currentTab: 0,
      breadcrumbItems: [
        {
          text: this.$t('segments'),
          disabled: false,
          href: '/admin/clinic/segments'
        },
        {
          text: this.$t('segment_detail'),
          disabled: false,
          href: `/admin/clinic/segments/${this.id}`
        },
        {
          text: this.$t('send_message'),
          disabled: true
        }
      ],
      message: null,
      eventName: null,
      smsHeader: '',
      editingHeader: false,
      isSavingHeader: false,
      smsHeaderRules: [v => !!(v && v.toString().trim().length) || 'This field is required'],
      openSendMessageDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      selectedDonors: 'donation/getSelectedDonors'
    }),
    creditBalance() {
      return this.company.prepaid_credits
    },
    messageLength() {
      let text = this.message || ''
      text = text + this.senderIDPrefix
      const length = text ? text.length : 0
      const charLength = 155
      const numSMS = Math.ceil(length / charLength)
      const cost = numSMS * 0.15
      return { length, numSMS, cost }
    },
    hasSmsHeader () {
      return !!(this.smsHeader && this.smsHeader.toString().trim().length)
    },
    senderID () {
      if (this.hasSmsHeader) {
        return `RM0 ${this.smsHeader}`
      }
      return null
    },
    senderIDPrefix () {
      if (this.senderID) {
        return `${this.senderID}: `
      }
      return ''
    },
    disabledSend () {
      if (this.message && this.eventName && this.hasSmsHeader) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.fetchMarketingSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMarketingSettings () {
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.smsHeader = resp.data.sms_header || ''
          if (!this.smsHeader) {
            this.editingHeader = true
          }
        })
        .catch(() => {})
    },
    saveSmsHeader () {
      if (!this.smsHeader || !this.smsHeader.toString().trim().length) {
        this.showMessage(['error', 'This field is required'])
        return
      }
      this.isSavingHeader = true
      this.$axios.patch(`/marketing/${this.company.slug}`, { sms_header: this.smsHeader })
        .then(() => {
          this.editingHeader = false
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isSavingHeader = false
        })
    },
    closeRedirect () {
      this.$router.push(`/admin/clinic/segments/${this.id}`)
    }
  },
  destroyed () {
    this.$store.commit('donation/resetSelectDonors')
  }
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>